import { writable } from "svelte/store";
import { get as getStoreValue } from "svelte/store";
import isArray from "lodash/isArray";
import { HttpPromise } from "@shared/svelte/Modules/ApiService";

export default function RestStore(
  initialValue: any,
  baseUrl: string,
  model: string,
  baseParams = "",
  getUrl = null,
  updateUrl = null,
) {
  const store: any = writable(initialValue);
  const errors: any = writable(null);

  const remove = async () => {
    errors.update(() => null);

    let storeVal: { id: number } = getStoreValue(store);
    let method = "DELETE";

    if (!storeVal.id) {
      return;
    }

    let myUrl = baseUrl + `/${storeVal.id}`;

    if (baseParams) {
      myUrl += `?${baseParams}`;
    }

    const options = {
      method: method,
      url: baseUrl + `/${storeVal.id}`,
    };

    let resJson;
    try {
      resJson = await HttpPromise(options);

      store.update(res => {
        res._destroyed = true;
        return res;
      });
    } catch (errorJson) {
      if (isArray(errorJson)) {
        errors.update(() => {
          return { messages: errorJson };
        });
      } else if (errorJson.errors && isArray(errorJson.errors.messages)) {
        errors.update(() => {
          return { messages: errorJson.errors.messages };
        });
      }

      return Promise.reject(errorJson);
    }

    return resJson;
  };

  const persist = async (params = null) => {
    errors.update(() => null);

    let storeVal: { id: number } = getStoreValue(store);
    let method = "POST";
    let myUrl = baseUrl;

    if (storeVal.id) {
      if (updateUrl) {
        myUrl = updateUrl;
      } else {
        myUrl += `/${storeVal.id}`;
      }
      method = "PUT";
    }

    if (baseParams) {
      myUrl += `?${baseParams}`;
    }

    let dataToSend;

    if (params) {
      dataToSend = params;
    } else {
      dataToSend = storeVal;
    }

    let body = {};
    body[model] = dataToSend;

    const options = {
      method: method,
      url: myUrl,
      data: body,
    };

    let resJson;

    try {
      resJson = await HttpPromise(options);
      store.update(() => {
        return resJson;
      });
    } catch (errorJson) {
      if (isArray(errorJson)) {
        errors.update(() => {
          return { messages: errorJson };
        });
      } else if (errorJson.errors && isArray(errorJson.errors.messages)) {
        errors.update(() => {
          return { messages: errorJson.errors.messages };
        });
      }

      return Promise.reject(errorJson);
    }

    return resJson;
  };

  const get = async (id: number) => {
    let resUrl;
    if (getUrl) {
      resUrl = getUrl;
    } else {
      resUrl = `${baseUrl}/${id}`;
    }

    const options = {
      method: "GET",
      url: resUrl,
    };

    let resJson;
    try {
      resJson = await HttpPromise(options);
      store.update(() => resJson);
    } catch (errorJson) {
      return Promise.reject(errorJson);
    }
  };

  store.get = get;
  store.set = obj => store.update(() => obj);
  store.remove = remove;
  store.save = persist;
  store.errors = errors;

  return store;
}
